module.exports = __webpack_public_path__ + "img/mengyang-android.d19e4aed.png";